import { render, staticRenderFns } from "./landing-videos.vue?vue&type=template&id=87c01f6e&scoped=true&"
import script from "./landing-videos.vue?vue&type=script&lang=js&"
export * from "./landing-videos.vue?vue&type=script&lang=js&"
import style0 from "./landing-videos.vue?vue&type=style&index=0&id=87c01f6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c01f6e",
  null
  
)

export default component.exports